// 9fbef606107a605d69c0edbcd8029e5d
import SMS_SUBSCRIPTION_CONSTANTS from './SubscriptionSMS.constants';

export const submitSmsSubscription = (payload) => {
  return {
    payload,
    type: SMS_SUBSCRIPTION_CONSTANTS.SUBSCRIPTION_SMS_SUBMIT,
  };
};

export const statusSMSSubscription = (payload) => {
  return {
    payload,
    type: SMS_SUBSCRIPTION_CONSTANTS.SUBSCRIPTION_SMS_STATUS,
  };
};
